import { Component, OnInit } from '@angular/core';
import { RepaymentsService } from './../../../services/repayments.service';
import { ActivatedRoute, Router } from '@angular/router';
import 'jspdf-autotable';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import * as moment from 'moment';
import { of } from 'rxjs';
import {
  mergeMap,
  filter,
  tap,
  map,
  toArray,
  pluck,
  switchMap,
} from 'rxjs/operators';

@Component({
  selector: 'app-repayment-by-user',
  templateUrl: './repayment-by-user.component.html',
  styleUrls: ['./repayment-by-user.component.css'],
})
export class RepaymentByUserComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  filterWnameArr: Array<any> = [];
  fromDate: any;
  toDate: any;
  loanDataToShow: any;
  cmdShow: boolean = true;
  whrShow: boolean;
  loanShow: boolean;
  loanAppsLoaded: Boolean = false;
  totalRec: number;

  emailForm: FormGroup;
  sendingEmail: boolean = false;

  reqQuery: any;

  isOneWeekFilter: boolean = false;
  isCurrentMonthFilter: boolean = false;
  isOneMonthFilter: boolean = false;
  isCurrentYearFilter: boolean = false;
  isOneYearFilter: boolean = false;

  constructor(
    private fb: FormBuilder,
    private lservice: RepaymentsService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  disableAllFilterBoolean() {
    this.isOneWeekFilter = false;
    this.isCurrentMonthFilter = false;
    this.isOneMonthFilter = false;
    this.isCurrentYearFilter = false;
    this.isOneYearFilter = false;
  }

  setFilterBoolean(range) {
    this.disableAllFilterBoolean();
    switch (range) {
      case '1W':
        this.isOneWeekFilter = true;
        return;
      case 'MTD':
        this.isCurrentMonthFilter = true;
        return;
      case '1M':
        this.isOneMonthFilter = true;
        return;
      case 'YTD':
        this.isCurrentYearFilter = true;
        return;
      case '1Y':
        this.isOneYearFilter = true;
        return;
    }
  }

  ngOnInit() {
    this.emailForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$'),
        ],
      ],
    });

    this.route.queryParams
      .pipe(
        switchMap((value) => of(value)),
        tap((value) => this.setFilterBoolean(value.range)),
        tap((value) => {
          if (value.range) {
            this.fromDate = null;
            this.toDate = null;
          } else {
            this.fromDate = value.fromDate;
            this.toDate = value.toDate;
          }
        }),
        map((value) => {
          const params = { ...value };
          this.p = params.page || 1;

          params.page = this.p;
          params.limit = this.itemsPerPage;
          return params;
        }),
        map((value) => {
          let query: any = {
            page: value.page,
            limit: value.limit,
          };

          if (value.fromDate && value.toDate) {
            query.fromDate = value.fromDate;
            query.toDate = value.toDate;
          }

          return query;
        })
      )
      .subscribe((query) => {
        this.getRepaymentByUser(query);
      });
  }

  onEmailSubmit() {
    const { fromDate, toDate, range } = this.route.snapshot.queryParams;

    const query: any = {
      sendBy: 'email',
      email: this.emailForm.get('email').value,
      fileName: `${
        range ? `${range}_` : ''
      }MIS_Repayment_Report-${new Date().toDateString()}`,
      reportName: 'Repayment Report',
    };

    if (fromDate && toDate) {
      query.fromDate = fromDate;
      query.toDate = toDate;
    }

    this.loanAppsLoaded = false;
    this.sendingEmail = true;

    this.lservice.repaymentByApplicants(query).subscribe(
      () => {
        this.sendingEmail = false;
        this.loanAppsLoaded = true;
        this.toastr.success(
          `Email sent to  ${this.emailForm.get('email').value}`
        );
      },
      () => {
        this.sendingEmail = false;
        this.loanAppsLoaded = true;
        this.toastr.error('Cant send email');
      }
    );
  }

  getRepaymentByUser(query = {}) {
    this.dataToShow = [];
    this.loanAppsLoaded = false;

    this.lservice.repaymentByApplicants(query).subscribe((data) => {
      this.loanAppsLoaded = true;

      this.lApplications = data['data'];
      this.dataToShow = data['data'];
      this.totalRec = data['totalRec'];
    });
  }

  fileWriteObj(data) {
    return {
      'Applicant Name': data.applicantName,
      'Approved Loan Amount': data.approvedLoanAmount,
      'Released Amount': data.releasedAmount,
    };
  }

  downloadFile(fileType = 'csv') {
    const { fromDate, toDate } = this.route.snapshot.queryParams;

    const query: any = {};

    if (fromDate && toDate) {
      query.fromDate = fromDate;
      query.toDate = toDate;
    }

    this.loanAppsLoaded = false;
    this.lservice
      .repaymentByApplicants(query)
      .pipe(
        pluck('data'),
        mergeMap((values: any[]) => of(...values)),
        map((value) => {
          const loanApp = { ...value };
          return this.fileWriteObj(loanApp);
        }),
        toArray()
      )
      .subscribe(
        (loanApps: any) => {
          this.loanAppsLoaded = true;
          if (fileType === 'pdf') {
            this.writeToPDF(loanApps);
          } else {
            this.writeToCSV(loanApps);
          }
        },
        (err) => {
          console.log(err);
          this.loanAppsLoaded = true;
          this.toastr.error('Something went wrong!!!');
        }
      );
  }

  print() {}

  writeToCSV(data) {
    let headers = [];
    if (data.length) {
      headers = Object.keys(data[0]);
    }

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      headers: headers,
      showTitle: false,
      title: 'name',
      useBom: false,
      removeNewLines: true,
      noDownload: false,
    };

    new AngularCsv(
      data,
      'MIS_Repayment_Report-' + new Date().toDateString(),
      options
    );
  }

  writeToPDF(data) {
    let headers = [];
    if (data.length) {
      headers = Object.keys(data[0]);
    }

    const doc = new jsPDF('landscape');
    const rows = data.map((d) => headers.map((h) => d[h]));

    doc.setFontSize(9);
    doc.autoTable(headers, rows);
    doc.save('MIS_Repayment_Report-' + new Date().toDateString() + '.pdf');
  }
  onResetClick() {
    this.router.navigateByUrl('/repayment/applicants');
  }

  onRowClick(value) {
    this.router.navigate(['/loanapplicationdetails'], {
      queryParams: {
        id: value._id,
        uId: value.submittedBy,
      },
    });
  }

  getReportbyDateRange() {
    if (!this.fromDate || !this.toDate) {
      return;
    }

    this.router.navigate(['/repayment/applicants'], {
      queryParams: {
        fromDate: this.fromDate,
        toDate: this.toDate,
        page: 1,
      },
    });
  }

  getOneWeekReport() {
    const today = moment().format('YYYY-MM-DD');
    const weekStart = moment().subtract(1, 'weeks').format('YYYY-MM-DD');

    this.router.navigate(['/repayment/applicants'], {
      queryParams: {
        fromDate: weekStart,
        toDate: today,
        range: '1W',
        page: 1,
      },
    });
  }

  getCurrentMonthReport() {
    const today = moment().format('YYYY-MM-DD');
    const monthStart = moment().startOf('month').format('YYYY-MM-DD');

    this.router.navigate(['/repayment/applicants'], {
      queryParams: {
        fromDate: monthStart,
        toDate: today,
        range: 'MTD',
        page: 1,
      },
    });
  }

  getOneMonthReport() {
    const today = moment().format('YYYY-MM-DD');
    const monthStart = moment().subtract(1, 'months').format('YYYY-MM-DD');

    this.router.navigate(['/repayment/applicants'], {
      queryParams: {
        fromDate: monthStart,
        toDate: today,
        range: '1M',
        page: 1,
      },
    });
  }

  getCurrentYearReport() {
    const today = moment().format('YYYY-MM-DD');
    const yearStart = moment().startOf('year').format('YYYY-MM-DD');

    this.router.navigate(['/repayment/applicants'], {
      queryParams: {
        fromDate: yearStart,
        toDate: today,
        range: 'YTD',
        page: 1,
      },
    });
  }

  getOneYearReport() {
    const today = moment().format('YYYY-MM-DD');
    const yearStart = moment().subtract(1, 'years').format('YYYY-MM-DD');

    this.router.navigate(['/repayment/applicants'], {
      queryParams: {
        fromDate: yearStart,
        toDate: today,
        range: '1Y',
        page: 1,
      },
    });
  }
  getNewPage($event) {
    this.router.navigate(['/repayment/applicants'], {
      queryParams: {
        page: $event,
      },
      queryParamsHandling: 'merge',
    });
  }

  goBack() {
    this.router.navigateByUrl('/reports');
  }
}
